import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { NetworkStatus } from '@shared/models/network-status.model'

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private _status = new BehaviorSubject<NetworkStatus | null>(null)
  readonly status$ = this._status.asObservable()

  setStatus(status: NetworkStatus): void {
    this._status.next(status)
  }
}
